import { Link } from "react-router-dom";
import Reveal from "./reveal";

const CATEGORY_LABELS = {
  uxui: "UX/UI",
  vdxr: "Games & XR",
  other: "Other",
};

export default function FeaturedProjectsBento({ items = [] }) {
  return (
    <section className="section-space-sm bg-white pt-0">
      <div className="page-shell grid grid-cols-1 gap-x-8 gap-y-12 lg:grid-cols-2">
        {items.map((project, index) => (
          <Reveal key={project.id} delay={index * 90}>
            <Link
              to={`/detail/${project.id}`}
              className="portfolio-card group block"
            >
              <div className="portfolio-frame">
                <img
                  src={project.imageSrc}
                  alt={project.imageAlt}
                  className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
                <div className="portfolio-label absolute left-4 top-4 inline-flex items-center rounded-full border border-white/70 bg-white/90 px-3 py-1.5 font-manrope text-[11px] font-semibold uppercase tracking-[0.14em] text-[#270400]/80 backdrop-blur-sm">
                  {CATEGORY_LABELS[project.category] || project.category}
                </div>
              </div>
              <div className="portfolio-copy px-1 pt-5">
                <div>
                  <h3 className="font-urbanist text-[1.6rem] font-semibold leading-[1.05] text-[#270400] transition-colors duration-300 group-hover:text-[#E63A27] sm:text-[2rem]">
                    {project.name}
                  </h3>
                  <p className="mt-3 max-w-[40ch] font-manrope text-sm leading-6 text-[#270400]/75 sm:text-[15px]">
                    {project.tinDescription}
                  </p>
                </div>
              </div>
            </Link>
          </Reveal>
        ))}

        <Reveal delay={items.length * 90 + 80} className="lg:col-span-2">
          <Link
            to="/projects"
            className="group relative overflow-hidden py-2 text-[#270400]"
          >
            <div className="relative grid gap-4 sm:grid-cols-[1.1fr_1fr] sm:items-end sm:gap-6">
              <div>
                <p className="font-manrope text-sm uppercase tracking-[0.18em] text-[#270400]/55">
                  Explore more
                </p>
                <h3 className="font-urbanist mt-3 text-3xl font-semibold text-[#270400] transition-colors duration-300 group-hover:text-[#E63A27] sm:text-4xl">
                  See all projects
                </h3>
              </div>
              <div className="sm:justify-self-end sm:text-right">
                <p className="mt-4 inline-flex items-center gap-2 font-urbanist text-4xl font-semibold text-[#E63A27] transition-transform duration-300 group-hover:translate-x-1">
                  <span aria-hidden="true" className="font-manrope">-&gt;</span>
                  All projects
                </p>
              </div>
            </div>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
